module.exports = __webpack_public_path__ + "static/media/angel.80ecec3e.png";